import * as Sentry from '@sentry/vue'
import type { App } from 'vue'
import type { Router } from 'vue-router'

export const initSentry = (app: App, router: Router) => {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration()
    ],
    enableLogs: true,
    tracesSampleRate: 0.05,
    tracePropagationTargets: [import.meta.env.VITE_APP_URL],
    environment: import.meta.env.VITE_ENV,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 0.5
  })
}
